import React, { useEffect } from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useLoginRedirect } from '../hooks';
export const Login = () => {
    const onRedirect = useLoginRedirect();
    useEffect(() => {
        onRedirect();
    }, [onRedirect]);
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, "Please wait while you're logged in..."),
        React.createElement(LinearProgress, { style: { marginVertical: 10 } })));
};
//# sourceMappingURL=Login.js.map